<template>
    <div class="card-body">
        
        <ul class="list-group my-2">
            <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="text-muted font-weight-bolder d-flex">Aprobados</span>
                <span class="label label-success font-weight-bolder label-lg badge-pill" v-text="sumary.st2"></span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="text-muted font-weight-bolder d-flex">Anulados</span>
                <span class="label label-danger font-weight-bolder label-lg badge-pill" v-text="sumary.st3"></span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="text-muted font-weight-bolder d-flex">Subsanar</span>
                <span class="label label-info font-weight-bolder label-lg badge-pill" v-text="sumary.st5"></span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="text-muted font-weight-bolder d-flex">Revision</span>
                <span class="label label-warning font-weight-bolder label-lg badge-pill" v-text="sumary.st4"></span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="text-muted font-weight-bolder d-flex">Borrador</span>
                <span class="label label-light-dark font-weight-bolder label-lg badge-pill" v-text="sumary.st1"></span>
            </li>
        </ul>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data:() => ({sumaryStatus:{st1: 0, st2: 0, st3: 0, st4: 0, st5:0}}),
    computed: {
        ...mapGetters(['currentDataListAcrd']),
        sumary(){
            this.sumaryStatus.st1 = this.sumaryStatus.st2 = this.sumaryStatus.st3 = this.sumaryStatus.st4 = this.sumaryStatus.st5 = 0;
            this.currentDataListAcrd.forEach(element => {
                if(element.checkdoc == '0') //borrador
                    this.sumaryStatus.st1 += 1;
                if(element.checkdoc == '1') //aprobados
                    this.sumaryStatus.st2 += 1;
                if(element.checkdoc == '2') //anulados
                    this.sumaryStatus.st3 += 1;
                if(element.checkdoc == '3') //enviados a revision
                    this.sumaryStatus.st4 += 1;
                if(element.checkdoc == '4') //subsanar
                    this.sumaryStatus.st5 += 1;
            });
            return this.sumaryStatus;
        }
    }
}
</script>